import * as React from 'react';
import { OnIgnoreEnter } from '../AnalyseApp';

interface AnalysisSetsButtonProps {
    onClick: () => void;
    activeAnalysisSetsCount: number;
}

export const AnalysisSetsButton = ({ onClick, activeAnalysisSetsCount }: AnalysisSetsButtonProps) => {
    return (
        <button id="AnalysisSets" className="btn btn-primary" type="button" onClick={() => onClick()} onKeyDown={OnIgnoreEnter}>
            <i className="fa fa-clone"></i>
            &nbsp;Analysis Sets&nbsp;
            <span id="AnalysisSetsCountBadge" className="badge badge-info">{activeAnalysisSetsCount}</span>
        </button>
    );
}
